import {LIST_VIEW_LOCALSTORAGE_ITEM_NAME} from '../constants';
import { IListViewState } from '../store/listView/types';

const DEFAULT_VALUE = {};

export const getLocalStorageItem =
(): IListViewState => {
    if (!localStorage) return {};
    const localStorageItem = localStorage.getItem(LIST_VIEW_LOCALSTORAGE_ITEM_NAME);
    return localStorageItem ? JSON.parse(localStorageItem) : DEFAULT_VALUE;
};
